import React from 'react';
import Sidebar from '../Sidebar';
import PatientAppointmentHistory from '../../Components/PatientAppointmentHistory';


const AppintmentHistory = () => {

    return (
        
        <React.Fragment>
            <Sidebar showAppointments={false}/>
            <div className='container'>
                <div className="card">
                    <h2>Appointments History</h2>
                    <PatientAppointmentHistory />
                </div>
            </div>
        </React.Fragment>
    );
}

export default AppintmentHistory;
